<template>
    <div class="chat-message">
        <div :class="{'flex items-end': true, 'justify-end': message.is_customer_message === false}">
            <div :class="{'flex flex-col space-y-2 text-xs max-w-xs mx-2 order-2': true, 'items-start': message.is_customer_message === false, 'items-end': message.is_customer_message === true}">
            <div>
                <span :class="{
                'px-4 py-2 rounded-lg inline-block rounded-bl-none': true,
                'bg-gray-300 text-gray-600': message.is_customer_message === true,
                'bg-blue-600 text-white': message.is_customer_message === false
                }">
                {{ message.text }}
                </span>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        message: Object
    }
}
</script>